import { render } from "./BestPractices.vue?vue&type=template&id=3f3211aa&scoped=true"
import script from "./BestPractices.vue?vue&type=script&lang=js"
export * from "./BestPractices.vue?vue&type=script&lang=js"

import "./BestPractices.vue?vue&type=style&index=0&id=3f3211aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3211aa"]])

export default __exports__